import { formatCurrencyNoDecimals } from '@/utils/formatters';
import type { InvestorDrawdownSummary } from './services/drawdowns-service';

export function invoiceBreakdown(
  allocation: InvestorDrawdownSummary['investor_allocation']
): string | null {
  const parts = [
    `Capital call ${formatCurrencyNoDecimals(allocation.drawdown_amount)}`,
  ];
  if (allocation.prepayment_contribution > 0) {
    parts.push(
      `+ prepayment due to regulation ${formatCurrencyNoDecimals(allocation.prepayment_contribution)}`
    );
  }
  if (allocation.prepayment_used > 0) {
    parts.push(
      `− prepayment applied ${formatCurrencyNoDecimals(allocation.prepayment_used)}`
    );
  }
  return parts.length > 1 ? parts.join(' ') : null;
}
